import React from "react";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

const AuthGuard = ({ children }) => {
  const [user, setUser] = React.useState(auth.currentUser);
  const [loading, setLoading] = React.useState(true);
  const navigate = useNavigate();

  React.useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(u => {
      setUser(u);
      setLoading(false);
      if (!u) navigate("/signup");
    });
    return unsubscribe;
  }, [navigate]);

  if (loading) return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  if (!user) return null;
  return children;
};
export default AuthGuard;
